module.exports = __webpack_public_path__ + "static/media/onboarding.f386b3f7.png";